import Pusher from 'pusher-js'
import { Notification } from 'element-ui'
import Store from '@/store'
import { SET_CACHE } from '@/store/mutation-types'

const CACHE_TYPE = 'events'
const CACHE_KEY = 'pusher'
const MAX_EVENTS = 50

class PusherService {
  constructor () {
    if (!window.mattwantspusher) {
      console.warn('Pusher is not supported in this environment')
      return
    }
    this.messages = Store.getters['cache/events'](CACHE_KEY) || []
    this.events = []

    Pusher.logToConsole = process.env.NODE_ENV === 'development' || false

    const pusher = new Pusher('70cb5b045e59760feca6', {
      cluster: 'ap4'
    })

    const channel = pusher.subscribe(process.env.VUE_APP_PUSHER_CHANNEL || 'openfreight')

    this.events.forEach(code => {
      channel.bind(code, (data) => {
        this.messages = [data, ...this.messages].slice(0, MAX_EVENTS)
        this.commitMessages()
        // eslint-disable-next-line
        Notification({
          type: data.type,
          duration: data.duration ? data.duration : 0,
          title: data.title,
          message: data.message,
          offset: 75
        })
      })
    })
  }
  commitMessages () {
    Store.commit(`cache/${SET_CACHE}`, {
      type: CACHE_TYPE,
      url: CACHE_KEY,
      results: this.messages
    })
  }
  clearMessages () {
    this.messages = []
    this.commitMessages()
  }
  subscribe (event) {
    this.events.push(event)
    console.log(`Subscribed to event: ${event}`)
  }
}
export default function install (Vue) {
  const pusher = new PusherService()
  Object.defineProperty(Vue, '$pusher', { value: pusher })
  Object.defineProperty(Vue.prototype, '$pusher', { value: pusher })
}
